var a={};export{a as default};
//# sourceMappingURL=Signer.js.map
